import { useQuery } from '@tanstack/react-query';
import {
  AvailabilityPerHost,
  fetchAvailableDatesPerHost,
} from 'flux/clients/experiences';

export const AVAILABLE_DATES_QUERY_KEY = (experienceId: string) => [
  'available-dates',
  experienceId,
];
export const AVAILABLE_DATES_QUERY_FN = (experienceId: string) => () =>
  fetchAvailableDatesPerHost(experienceId);

function toAvailableDatesFormat(response: AvailabilityPerHost) {
  const result: Record<string, Set<string>> = {};
  if (!response) {
    return [];
  }
  const { availability } = response;

  Object.entries(availability).forEach(([hostId, dates]) => {
    dates.forEach((date) => {
      if (!result[date]) {
        result[date] = new Set();
      }
      result[date].add(hostId);
    });
  });

  return Object.entries(result).map(([date, localsSet]) => ({
    date,
    locals: Array.from(localsSet),
  }));
}

function useAvailableDates(experienceId: string) {
  const query = useQuery({
    queryKey: AVAILABLE_DATES_QUERY_KEY(experienceId),
    queryFn: AVAILABLE_DATES_QUERY_FN(experienceId),
    onError: (error: any) => error,
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: !!experienceId,
  });

  return {
    ...query,
    availableDates: toAvailableDatesFormat(query.data),
  };
}

export default useAvailableDates;
